import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {AccountService} from "../core/auth/account.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Component({
    selector: 'app-sso-inexweb-logged',
    templateUrl: './sso-inexweb-logged.component.html',
    styleUrls: ['./sso-inexweb-logged.component.css']
})
export class SsoInexwebLoggedComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private accountService = inject(AccountService);
  private http = inject(HttpClient);


  private apiUrl = environment.apiUrl;

  private static setSessionToken(jwt: string): void {
    localStorage.setItem('accessToken', jwt);
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe((params: Params) => {
        const token = String(params.token);
        SsoInexwebLoggedComponent.setSessionToken(token);

        this.accountService.identity().then((authenticated: boolean) => {
          if (!authenticated) {
            this.router.navigate(['login']).then();
          }

          /* eslint @typescript-eslint/no-unsafe-member-access: 0 */
          /* eslint @typescript-eslint/no-unsafe-assignment: 0 */
          const jsonParseToken = JSON.parse(atob(token.split('.')[1]));
          const email = jsonParseToken.sub as string;
          localStorage.setItem('email', email);
          if (typeof jsonParseToken.provider === "string") {
            localStorage.setItem('provider', jsonParseToken.provider as string);
          }
          if (localStorage.getItem('ieo_cb_reference') != null && localStorage.getItem('ieo_cb_amount') != null) {
            const body = {
              email: String(email),
              reference: localStorage.getItem('ieo_cb_reference'),
              amount: localStorage.getItem('ieo_cb_amount')
            };
            this.http.post(this.apiUrl + '/checkout/send-recap-mail', body, {observe: 'response', responseType: 'text'})
              .subscribe(() => {
                localStorage.removeItem('ieo_cb_reference');
                localStorage.removeItem('ieo_cb_amount');
              });
          }
          this.router.navigate(['switch-company']).then();
        });
      });
  }
}
